var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_vm.loading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "article, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line"
    }
  }) : _vm.isReportV2 ? _c('partner-report-detail-v2') : _c('partner-report-detail', {
    attrs: {
      "displayToDetailView": false
    },
    on: {
      "setReport": _vm.goToList
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }